<script>
import {onMounted, reactive, toRefs} from 'vue';
import {axios} from "../helpers";

export default {
  name: 'RegisteredOnCourse',
  props: {
    courseId: {
      type: Number,
      required: true
    },
  },
  setup(props) {
    const data = reactive({
      count: 0,
      registered: [],
      hoveredId: null,
    });

    function load() {
      let req = {
        action: 'registeredOnCourse',
        courseId: props.courseId,
      };
      axios.fetchPost(window.xhrLink, req).then((registered) => {
        data.registered = registered;
      });
    }

    function removeRegistration(registration) {
      const email = prompt('Pro odebrání přihlášky zadejte e-mail, který byl použit při její tvorbě:');
      if (!email || !email.trim()) {
        return;
      }

      let req = {
        action: 'removeRegistration',
        registrationId: registration.id,
        email: email.trim(),
      };

      axios.fetchPost(window.xhrLink, req).then((message) => {
        alert(message || 'Přihláška byla úspěšně smazána.');
        data.registered = data.registered.filter(r => r.id !== registration.id);
      });
    }

    onMounted(_ => {
      load();
    });

    return {
      ...toRefs(data),
      removeRegistration,
    }
  }
}
</script>

<template>
  <p v-if="registered.length > 0">
    <strong>Přihlášení: </strong>
    <span
      v-for="registration in registered"
      :key="registration.id"
      class="registered-item-card-shadowed"
      @mouseenter="hoveredId = registration.id"
      @mouseleave="hoveredId = null"
    >
      {{ hoveredId === registration.id ? registration.fullName : registration.label }} <em class="fa-light fa-trash-alt registered-item-tag" @click="removeRegistration(registration)" title="Odebrat přihlášku"></em>
    </span>
  </p>
</template>

<style scoped>
.registered-item-card-shadowed {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  background-color: #f0f0f0;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.25);
}

.registered-item-tag {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  color: rgb(30 30 231 / 0.4);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.registered-item-tag:hover {
  background-color: rgb(30 30 231 / 0.2);
}
</style>